// extracted by mini-css-extract-plugin
export default {"heading":"ww-z","corrected":"xw-z","redirectVerbiageContainer":"yw-z","redirectVerbiageText":"zw-z"};